import React, { Component } from 'react';
import * as func from "../../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../../wpconfig"

class Item extends Component {
  constructor(props) {
    super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isEdit: r.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : r,
		}
  }

  componentDidMount() {
  }

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

    const { record } = this.props

		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (record.scholar_id) {
				func.updateData("admin/scholar/"+func.getParams("record_id")+"/career/update", record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							record : JSON.parse(JSON.stringify(record))
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				if (this.career_role.value === '') {
					this.career_role.focus();
				} else {
					func.updateData("admin/scholar/"+func.getParams("record_id")+"/career/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
              isEdit = EDIT_MODE.SHOW_EDIT;
						}
            this.setState({'isEdit': isEdit});
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	}

	onCloseDelete = (event) => {
		event.preventDefault()
		if (this.props.record.scholar_id) {
			if (this.state.isEdit) {
				Object.keys(this.state.record).map((key) => {
					if(this[key]) {
						this[key].value = this.state.record[key]
					}
				});
				this.props.onUpdate(this.props.arrIndex, this.state.record, true);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm('pnu 임용정보 : ' + this.props.record.career_org + '(' + this.props.record.career_role + ')을(를) ' + MESSAGE.DELETE)) {
					func.updateData("admin/scholar/"+func.getParams("record_id")+"/career/delete", this.props.record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		// this.setState({'isEdit': EDIT_MODE.SHOW});
		// if (this.props.record.author_id) {
		// 	this.props.onUpdate(this.props.arrIndex, this.state.record);
		// } else {
		// 	this.props.onRemove(this.props.arrIndex)
		// }
	}

  onChange = (e) => {
    console.log(e);
  }

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, false);
	}
  
  render() {
    const { textEvent } = this
    const { record } = this.props

    return (
      <>
        {
          this.state.isEdit === EDIT_MODE.SHOW ?
          <tr className="list-row">
            <td scope="row"><input type="checkbox" className="ml-0" /></td>
            <td>
              { record.scholar_career_id }
            </td>
            <td>
              { record.start_yyyymm }
            </td>
            <td>
              { record.end_yyyymm }
            </td>
            <td>
              { record.career_org }
            </td>
            <td>
              { record.career_role }
            </td>
            <td>
              <div className="mt-1">
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="checkbox" name="open_yn" id="oa_yes" onChange={textEvent} checked={ record.open_yn == "Y" ? "checked" : "" } disabled="disabled" />
                </div>
              </div>
            </td>
            <td className="column-action">
              <button className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>편집</button>
              <button className="btn btn-outline-dark btn-sm cancel" onClick={this.onCloseDelete}>삭제</button>
            </td>
          </tr> 
          :
          <tr className="list-row">
            <td scope="row"><input type="checkbox" className="ml-0" /></td>
            <td>
              { record.scholar_career_id }
            </td>
            <td>
              <input 
								type="text" 
								name="start_yyyymm" 
								className="form-control" 
								ref={(ref)=>this.start_yyyymm=ref}
								value={record.start_yyyymm || ""} 
								onChange={textEvent}
							/>
            </td>
            <td>
              <input 
								type="text" 
								name="end_yyyymm" 
								className="form-control" 
								ref={(ref)=>this.end_yyyymm=ref}
								value={record.end_yyyymm || ""} 
								onChange={textEvent}
							/>
            </td>
            <td>
              <input 
								type="text" 
								name="career_org" 
								className="form-control" 
								ref={(ref)=>this.career_org=ref}
								value={record.career_org || ""} 
								onChange={textEvent}
							/>
            </td>
            <td>
              <input 
								type="text" 
								name="career_role" 
								className="form-control" 
								ref={(ref)=>this.career_role=ref}
								value={record.career_role || ""} 
								onChange={textEvent}
							/>
            </td>
            <td>
              <div className="mt-1">
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="checkbox" name="open_yn" id="oa_yes" onChange={textEvent} checked={ record.open_yn == "Y" ? "checked" : "" } />
                </div>
              </div>
            </td>
            <td className="column-action">
                {record[this.props.pkKey] ?
                  <button href="#" className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>수정</button>
                  :
                  <button href="#" className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>저장</button>
                }
                <button className="btn btn-outline-dark btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
            </td>
          </tr>
        }
      </>
    )
  }
}

export default Item;